import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';

const ProductionSearch = React.lazy(
  () => import('components/Production/Search/Search'),
);

function ScreensProductionsList() {
  return (
    <BaseLayout>
      <DocumentTitle>Production List</DocumentTitle>
      <Suspense fallback={<UILoader />}>
        <ProductionSearch />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensProductionsList;
